export class BuildingsCamIV64MockMeasurements {
    static readonly SRI = {
        clientName: "Sorama",
        companyName: "Sorama",
        investigatedObject: "Inner partition wall in between the Handheld team room and the Portal team room",
        isFieldMeasurement: true,
        lrDimension1: 6,
        lrDimension2: 4.6,
        lrDimension3: 3,
        roomSurfaceArea: 23.0,
        roomVolume: 40.0,
        measurementLocation: "Achtseweg Zuid 153H, Eindhoven",
        reverberationTime: 0.1,
        shiftedReference: [-13.0, -10.0, -7.0, -4.0, -1.0, 2.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 10.0, 10.0, 10.0, 10.0],
        soundReductionIndex: [
            2.4, 4.09, 13.5, 15.3, 20, 22.4, 25.3, 29.1, 28.9, 29.6, 32.4, 32.6, 31.7, 31.5, 31.2, 32.9, 33.8, 34.2, 34,
            33.3, 31.4,
        ],
        swDimension1: 13.5,
        swDimension2: 2,
        weightedSoundReductionIndex: 33,
        fileName: "Test SRI fileName",
    };

    static readonly STC = {
        clientName: "Sorama",
        companyName: "Sorama",
        investigatedObject: "Inner partition wall in between the Handheld team room and the Portal team room",
        isFieldMeasurement: true,
        lrDimension1: 6,
        lrDimension2: 4.6,
        lrDimension3: 3,
        roomSurfaceArea: 23.0,
        roomVolume: 40.0,
        measurementLocation: "Achtseweg Zuid 153H, Eindhoven",
        reverberationTime: 0.1,
        shiftedReference: [-13.0, -10.0, -7.0, -4.0, -1.0, 2.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 10.0, 10.0, 10.0, 10.0],
        soundReductionIndex: [
            2.4, 4.09, 13.5, 15.3, 20, 22.4, 25.3, 29.1, 28.9, 29.6, 32.4, 32.6, 31.7, 31.5, 31.2, 32.9, 33.8, 34.2, 34,
            33.3, 31.4,
        ],
        swDimension1: 13.5,
        swDimension2: 2,
        weightedSoundReductionIndex: 33,
        fileName: "Test STC fileName",
    };

    static readonly RT = {
        Client: "Mock client",
        CompanyName: "Mock company",
        DecayTime: 0,
        IsFieldMeasurement: true,
        MeasuredTime: "Mock T20",
        MeasurementDevice: "CAM iMock64",
        MeasurementLocation: "Mockseweg Zuid",
        OctaveMode: 1,
        Precision: 3,
        RT20ReverberationTimePerOctaveBand: [
            0.864658, 0.765437, 0.7025369, 0.5823826, 0.5466781, 0.4961221, 0.4814386, 0.4397056, 0.3978349, 0.3978373,
            0.3841638, 0.3841659, 0.3443009, 0.3443039, 0.303092, 0.3030954, 0.3030964, 0.2867311,
        ],
        RT30ReverberationTimePerOctaveBand: [
            1.3029078, 1.1971764, 1.0974472, 0.9997134, 0.8974384, 0.8319781, 0.7654488, 0.7025488, 0.629801, 0.5823951,
            0.5466944, 0.5466958, 0.4961385, 0.4814529, 0.4814539, 0.4397195, 0.4397207, 0.3978498,
        ],
        RT60ReverberationTimePerOctaveBand: [
            2.5998948000000004, 2.3453319, 2.1512525499999997, 1.8732872999999999, 1.71745555, 1.5761612500000002,
            1.4876067000000002, 1.3621072, 1.22655335, 1.1791510500000002, 1.1229401, 1.12294465, 1.0125898500000001,
            0.9979087500000001, 0.9360919, 0.8943626, 0.8943653, 0.82794645,
        ],
        ReverberationTime: 1.4071084260940552,
        Signal: "Mock White Noise",
        VolumeReceivingRoom: "Mock 90m³",
        fileName: "Test RT fileName",
    };

    static readonly SLR = {
        testDate: "01-01-2023",
        investigatedObject: "123",
        manufacturerName: "test manufacturer",
        operatingConditions: "test operating conditions",
        operatorName: "test operator name",
        productName: "test product name",
        reverberationTimeLoud: 0.12,
        reverberationTimeReduced: 0.22,
        roomSurfaceArea: 1.0,
        roomVolume: 2.0,
        speechLevelReduction: [
            13.260091781616211, 11.275373458862305, 13.41647720336914, 12.402090072631836, 12.660200119018555,
            12.35511302947998, 11.546774864196777,
        ],
        testLabName: "test lab name",
        weightedSpeechLevelReduction: 12.838615417480469,
        fileName: "Test SLR fileName",
    };
}
